import React from 'react';
import { ListProps } from 'react-admin';
import ServiceCataloguePage from '../Services/Catalogue/ServiceCataloguePage';
import { ServiceCatalogueConfig } from '../Services/Catalogue/types';

/**
 * The consumer's view of the catalogue: every service on offer, whoever owns
 * it, with what it takes to declare one — and none of the administration,
 * which belongs to the team that owns the service.
 */
const config: ServiceCatalogueConfig = {
    resource: 'browse_services',
    pov: 'consumer',
};

const ServiceCatalogueList = (props: ListProps) => (
    <ServiceCataloguePage config={config} listProps={props} />
);

export default ServiceCatalogueList;
